<template>
  <div class="flex-grid" :style="gridStyles">
    <div v-for="row in processedRows" :key="row.index" class="flex-grid__section">
      <slot :name="`header-${row.index}`"></slot>
      <div class="flex-grid__row" :style="{ gap: gapCols, alignItems }">
        <div
          v-for="col in row.data"
          :key="col.colIndex"
          class="flex-grid__col"
          :style="getColumnStyle(col.width)"
        >
          <slot :name="`col-${row.index}-${col.colIndex}`"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFlexGrid',
  props: {
    rows: { type: Array, required: true },
    gapRows: { type: [String, Number], default: '20px' },
    gapCols: { type: [String, Number], default: '20px' },
    marginTop: { type: [String, Number] },
    marginBottom: { type: [String, Number], default: '20px' },
    alignItems: { type: String, default: 'center' },
  },
  computed: {
    gridStyles() {
      return {
        marginTop: this.normalizeSize(this.marginTop),
        marginBottom: this.normalizeSize(this.marginBottom),
        gap: this.normalizeSize(this.gapRows),
      }
    },
    processedRows() {
      return this.rows.map((row, rowIndex) => {
        const rowIndexOffset = rowIndex + 1
        const rowData = row
          .map((colWidth, colIndex) => ({
            width: colWidth,
            colIndex: colIndex + 1,
            slotName: `col-${rowIndexOffset}-${colIndex + 1}`,
          }))
          .filter(col => !!this.$slots[col.slotName])
        return {
          index: rowIndexOffset,
          data: rowData,
        }
      })
        .filter(row => row.data.length > 0)
    },
  },
  methods: {
    normalizeSize(value) {
      return typeof value === 'number' ? `${value}px` : value
    },
    getColumnStyle(colWidth) {
      const size = this.normalizeSize(colWidth)
      return isNaN(colWidth) ? { width: size, flex: 'unset' } : { flex: colWidth }
    },
  },
}
</script>

<style lang="sass" scoped>
.flex-grid
  display: flex
  flex-direction: column
.flex-grid__row
  display: flex
  width: 100%
.flex-grid__col
  flex-grow: 1
</style>